import { AttendanceActivityApi } from '@/services/api/attendance-activity-api.ts';
import { UserApi } from '@/services/api/user-api.ts';
import { useMemoize } from '@vueuse/core';
import { ApprovalApi } from '@/services/api/approval-api.ts';
import { AttendanceMonthApi } from '@/services/api/attendance-month-api.ts';
import { AttendanceDayApi } from '@/services/api/attendance-day-api.ts';
import { SecomApi } from '@/services/api/secom-api.ts';
import { EmployeeApi } from '@/services/api/employee-api.ts';
import { CompanyApi } from '@/services/api/company-api.ts';
import { CompanyCalendarDayApi } from '@/services/api/calendar-day-api.ts';

export function useApi() {
  // 같은 context안에서는 캐싱된 API 인스턴스를 리턴
  // 추후 로그인에 따라 auth header 설정 등이 필요하면 여기 로직을 확장
  const cachedApis = useMemoize(() => {
    return {
      auth: new UserApi(),
      company: {
        company: new CompanyApi(),
        employee: new EmployeeApi(),
        calendarDay: new CompanyCalendarDayApi(),
      },
      approval: new ApprovalApi(),
      attendance: {
        activity: new AttendanceActivityApi(),
        month: new AttendanceMonthApi(),
        day: new AttendanceDayApi(),
      },
      secom: new SecomApi(),
    };
  });

  return cachedApis();
}
